// Used for k-transfer and markup
export const PRICE_LIST_ND = 'n.d.';
// Used for prices if priceType and price are null
export const PRICE_LIST_NA = 'na';

export const PRICE_LIST_PUBLISH_LEVEL_COLOR_MAP: { [key: string]: string } = {
  L1: 'rgb(197,217,241)',
  L2: 'rgb(255,192,0)',
  T1: 'rgb(196,215,155)',
  L5: 'rgb(217,217,217)',
  L6: 'rgb(255,204,255)',
  L7: 'rgb(255,255,255)',
  T2: 'rgb(146,208,80)',
};
